import { usePageMeta } from '@/hooks/usePageMeta';
import JsonLd from '@/components/feature/JsonLd';
import { faqs } from '@/mocks/faqs';
import { siteInfo } from '@/mocks/categories';
import Hero from './components/Hero';
import HotSection from './components/HotSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import SubscribeSection from './components/SubscribeSection';

export default function Home() {
  usePageMeta({
    title: '瓜田笔记 | 高校吃瓜趣闻与校园日常分享站',
    description:
      '瓜田笔记每天更新高校吃瓜趣闻与日常，分享宿舍夜聊、课堂八卦、社团趣事和食堂奇遇。真实轻松的校园吃瓜故事合集，陪你围观大学生活的另一面。',
    keywords: '高校吃瓜,高校吃瓜趣闻,高校吃瓜日常,高校吃瓜故事,高校吃瓜分享',
    path: '/',
  });

  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteInfo.name,
      description: siteInfo.description,
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${window.location.origin}/stories?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteInfo.name,
      description: siteInfo.description,
      email: siteInfo.email,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ];

  return (
    <>
      <JsonLd data={structuredData} />
      <Hero />
      <HotSection />
      <CategorySection />
      <LatestSection />
      <RankingSection />
      <TestimonialSection />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}